module.exports = __webpack_public_path__ + "img/teamSummary.52b5ff50.svg";